import { sum } from '@/utils/calculation';
import Decimal from '@/utils/decimal';

// Order line calculations

export const orderLineLineExtensionAmount = (
  quantity: Decimal,
  price: Decimal,
  allowanceChargeAmount: Decimal,
) => quantity.times(price).plus(allowanceChargeAmount).toDecimalPlaces(2);

export const orderLineTaxAmount = (
  lineExtensionAmount: Decimal,
  taxPercent: Decimal,
) => lineExtensionAmount.times(taxPercent).dividedBy(100).toDecimalPlaces(2);

// Order line allowance charge calculations

export const orderLineAllowanceChargeAmount = (
  quantity: Decimal,
  price: Decimal,
  percent: Decimal,
) => quantity.times(price).times(percent).dividedBy(100).toDecimalPlaces(2);

// Order allowance charge calculations

export const orderAllowanceChargeLineAmount = (
  lineExtensionAmountSum: Decimal,
  percent: Decimal,
) => lineExtensionAmountSum.times(percent).dividedBy(100).toDecimalPlaces(2);

// Order tax subtotals calculations

export const orderTaxSubtotalTaxableAmount = (
  lineExtensionAmounts: Decimal[],
  allowanceChargeAmounts: Decimal[],
) => sum(lineExtensionAmounts).add(sum(allowanceChargeAmounts)).toDecimalPlaces(2);

export const orderTaxSubtotalTaxAmount = (
  taxableAmount: Decimal,
  taxPercent: Decimal,
) => taxableAmount.times(taxPercent).dividedBy(100).toDecimalPlaces(2);

export const orderTaxSubtotalTaxInclusiveAmount = (
  taxableAmount: Decimal,
  taxAmount: Decimal,
) => taxableAmount.add(taxAmount).toDecimalPlaces(2);

// Order calculations

export const orderTaxAmount = (
  taxSubtotalAmounts: Decimal[],
) => sum(taxSubtotalAmounts).toDecimalPlaces(2);

export const orderLineExtensionAmount = (
  lineExtensionAmounts: Decimal[],
) => sum(lineExtensionAmounts).toDecimalPlaces(2);

export const orderTaxExclusiveAmount = (
  lineExtensionAmount: Decimal,
  allowanceChargeAmounts: Decimal[],
) => lineExtensionAmount.add(sum(allowanceChargeAmounts)).toDecimalPlaces(2);

export const orderTaxInclusiveAmount = (
  lineExtensionAmount: Decimal,
  taxAmount: Decimal,
) => lineExtensionAmount.add(taxAmount).toDecimalPlaces(2);

export const orderPayableAmount = (
  taxInclusiveAmount: Decimal,
) => taxInclusiveAmount.toDecimalPlaces(2);

